<ds-modal
  [modal]="modal"
  [colorVariant]="DsModalColorVariant.Default"
  [title]="pageTitle | translate"
  [backNavLabel]="backNavLabel"
>
  <app-page-form
    [config]="formConfig"
    [showUrl]="showUrl"
    [bannerText]="bannerText"
    [existingUrls]="existingUrls"
    [existingNames]="existingNames"
    [domainRestrictions]="domainRestrictions"
  ></app-page-form>

  <!--
  HACKING the width to be about 50 rem
  -->
  <div style="max-width: 50rem">
    <div style="width: 50rem"></div>
  </div>

  <ng-template ds-modal-slide-out-footer>
    <ds-button-group
      [primaryAction]="{ label: submitButtonLabel | translate }"
      [secondAction]="{ label: 'form_cancel' | translate, variant: DsButtonVariants.secondary }"
      (primaryActionClicked)="submit()"
      (secondActionClicked)="cancel()"
    >
    </ds-button-group>
  </ng-template>
</ds-modal>
